import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { ThemeDebugPanel } from "js/editor/editorPanels/debugPanel";
import Api from "js/core/api";
import { $, _ } from "js/vendor";
import perf from "js/core/utilities/perf";
import { getGlobal } from "reactn";
import getLocalStorage from "js/core/utilities/localStorage";
import logger from "js/core/logger";
import { getDebugAnalyticsState } from "js/analytics";

const localStorage = getLocalStorage();

class Debugger {
    get analytics() {
        return getDebugAnalyticsState();
    }

    get global() {
        window.console.log(getGlobal());
    }

    get perf() {
        return perf;
    }

    get slide() {
        ds.selection.slide.debug();
    }

    get primary() {
        return app.currentCanvas.layouter.elements.primary;
    }

    get elements() {
        _.each(app.currentCanvas.layouter.elements, element => {
            window.console.log(element.elements);
        });
    }

    get layouter() {
        return app.currentCanvas.layouter;
    }

    get tray() {
        return app.currentCanvas.layouter.elements.tray;
    }

    get presentation() {
        return ds.selection.presentation;
    }

    get model() {
        return app.currentCanvas.model;
    }

    get theme() {
        return app.currentTheme.attribute;
    }

    get layout() {
        window.console.log(app.currentCanvas.layouter.layout);
    }

    get canvas() {
        return app.currentCanvas.layouter.canvasElement;
    }

    get logger() {
        return logger;
    }

    get tree() {
        let logNodes = (element, indent) => {
            indent += 1;

            let log = "";
            for (let i = 0; i < indent; i++) {
                log += "----";
            }
            console.log(log + " " + element.toString());

            _.each(element.elements, element => logNodes(element, indent));
            indent -= 1;
        };

        _.each(app.currentCanvas.layouter.elements, element => {
            logNodes(element, 0);
            console.log("");
        });
    }

    get Api() {
        return Api;
    }

    showLayout() {
        this.eIndex = 0;
        this.showLayoutDebugBox = true;
        app.currentCanvas.refreshCanvasAutoRevert();
    }

    hideLayout() {
        this.showLayoutDebugBox = false;
        app.currentCanvas.refreshCanvasAutoRevert();
    }

    resetFirstTime() {
        app.user.update({ userInfo: null, hasTakenTour: null });
        app.user.save();
        window.location.reload();
    }

    get ds() {
        return ds;
    }

    showThemePanel() {
        let debugPanel = new ThemeDebugPanel();
        app.mainView.editorView.$canvasBounds.append(debugPanel.render().$el);
    }

    forceCanvasScale(scale = 1) {
        app.mainView.editorView.forceCanvasScale = scale;
        app.mainView.editorView.resize(true);
    }

    forceBrowserHeight(height) {
        if (height) {
            localStorage.setItem("forceBrowserHeight", height);
            $("#mainView").height(height);
        } else {
            localStorage.removeItem("forceBrowserHeight");
        }
    }

    resetUserInfo() {
        app.user.update({ userInfo: null });
        app.user.save();
        console.log("User info reset");
    }

    // async type(count = 25, speed = 30) {
    //     if (ds.selection.element instanceof TextElement) {
    //         let text = ds.selection.element;
    //         let $input = ds.selection.element.overlay.textEditor.$textInput;
    //         this.perf.reset();
    //
    //         let words = ["Then", "who", "can", "Beautiful.ai", "absolute", "temporary", "quantified", "appple", "pickle", "banana", "pear", "orange", "and", "some", "my", "kumquat", "avocado", "chocolate", "vanilla", "burrito"];
    //
    //         let sleep = () => {
    //             return new Promise(resolve => setTimeout(resolve, speed + (Math.ceil(Math.random(10)))));
    //         };
    //
    //         for (let i = 0; i < count; i++) {
    //             let word = words[Math.floor(Math.random() * words.length)];
    //
    //             for (let ch = 0; ch < word.length; ch++) {
    //                 $input.trigger({ type: "keypress", which: word.charCodeAt(ch) });
    //                 await sleep();
    //             }
    //             $input.trigger({ type: "keypress", which: " ".charCodeAt(0) });
    //             await sleep();
    //         }
    //
    //         this.perf.print();
    //     } else {
    //         console.log("Must select text element");
    //     }
    // }

    printTheme() {
        let str = "";
        for (let key in app.currentTheme.attributes) {
            let val = app.currentTheme.attributes[key];
            if (typeof (val) == "string") {
                val = `"` + val + `"`;
            }
            if (typeof (val) == "object") {
                val = JSON.stringify(val);
            }
            str += key + ":" + val + ",\n";
        }
        console.log(str);
    }
}

const debug = new Debugger();
export default debug;

window.debug = debug;
